export const QuestionAndOptions = {
    business_type: {
        question: {
            id: "business_type",
            name:"What kind of business do you run?", 
        },
        options: [
            {
                id: "sole_proprietorship",
                name: "Sole Proprietorship",
                description: "A business owned and operated by one individual, where there is no legal distinction between the owner and the business."
            },
            {
                id: "limited_liability_company",
                name: "Limited Liability Company (LLC)",
                description: "A business structure allowed by state statute that protects its owners from personal liability for the debts and actions of the LLC."
            }
            ,{
                id: "corporation",
                name: "Corporation",
                description: "A legal entity that is separate and distinct from its owners, providing limited liability to its shareholders."
            },
            {
                id: "partnership",
                name: "Partnership",
                description: "A business arrangement in which two or more individuals share ownership and the profits or losses of the business."
            },
            {
                id: "non_profit",
                name: "Charities and Nonprofits",
                description: "An organization that operates for a charitable purpose and does not distribute profits to its owners or shareholders."
            }
        ],

    }, business_name: {
        question: {
            id: "business_name",
            name: "Legal Business Name",
        }
    }, business_phone_number: {
        question: {
            id: "business_phone",
            name: "Preferred Phone Number",
            note: "We will use this number to contact you if needed. We do not share your information with third parties.",
        }
    }, business_ein: {
        question: {
            id: "business_ein",
            name: "Employer Identification Number (EIN)",                
        }
    }, business_employee_count: {
        question: {
            id: "business_employeeCount",
            name: "Number of Employees",
        },
        options: [
            { id: "1", name: "Just me" },
            { id: "1-10", name: "1-10 employees" },
            { id: "11-50", name: "11-50 employees" },
            { id: "51-100", name: "51-100 employees" },
            { id: "100+", name: "More than 100 employees" }
        ]
    }, business_address: {
        question: {
            id: "business_address",
            name: "Business Address",          
        }, 
        fields: [
            {
                id: "address_line1",
                name: "Street Address",                    
            },
            {
                id: "address_line2",
                name: "Apartment, Suite, etc.",                    
            },
            {
                id: "city",
                name: "City",                    
            },
            {
                id: "state",
                name: "State/Province/Region",                    
            },
            {
                id: "postal_code",
                name: "Zip Code",
                description: "The postal code for your business address."
            },
            {
                id: "country",
                name: "Country",
                description: "The country where your business is located."
            }
        ]            
    }, physical_store_address: {
        question: {
            id: "physical_store_address",
            name: "Do you have a physical store location?",
        },
        options: [
            {
                id: "yes",
                name: "Yes, but different from the registered address.",
                description: "I have a physical store location."
            },
            {
                id: "yes_same",
                name: "Yes, it is the same as my registered business address.",
                description: "I do not have a physical store location."
            },
            {
                id: "no",
                name: "No, I do not have a physical store location.",
                description: "I do not have a physical store location."
            }
        ]
    }
};